import * as runtypes from 'runtypes'

export type AutoShipOption = 1 | 2 | 3 | null

export type PrescriptionProduct = runtypes.Static<typeof PrescriptionProductRuntype>
export const PrescriptionProductRuntype = runtypes.Record({
  parentSku: runtypes.String,
  sku: runtypes.String,
  quantity: runtypes.Number,
  autoShip: runtypes.Union(
    runtypes.Literal(1),
    runtypes.Literal(2),
    runtypes.Literal(3),
    runtypes.Null,
  ),
  urlKey: runtypes.String,
  tags: runtypes.Optional(runtypes.Union(runtypes.Array(runtypes.String), runtypes.Nullish)),
})

export type Prescription = {
  products: ReadonlyArray<PrescriptionProduct>
  promoCode: string
}
export const PrescriptionRuntype = runtypes.Record({
  products: runtypes.Array(PrescriptionProductRuntype),
  promoCode: runtypes.String,
})

export type PrescriptionAction =
  | { type: 'add'; product: PrescriptionProduct }
  | { type: 'addMany'; products: PrescriptionProduct[] }
  | { type: 'remove'; sku: string }
  | { type: 'setPromoCode'; promoCode: string }
  | { type: 'updateQuantity'; sku: string; quantity: number }
  | { type: 'updateAutoShip'; sku: string; autoShip: AutoShipOption }
  | { type: 'updateProduct'; sku: string; product: PrescriptionProduct } // same as REMOVE then ADD
  | { type: 'clearAll' }
  | { type: 'set'; prescription: Prescription }
